import { useDispatch, useSelector } from 'react-redux';

import {cleanUpDataFieldMacro, cleanUpMacro, cleanUpMessageMacro, fetchGetExecuteFileData, fetchGetFieldData, fetchPostMacro} from "../../state-managament/macro.slice";

export default function useMacro(project) {
  const { fieldData, error, success, isLoaded, data } = useSelector((state) => state.macro);
  const dispatch = useDispatch();

  const getFieldData = (args) => {
    return dispatch(fetchGetFieldData(args))
  };
  const getExecuteFileData = (query) => dispatch(fetchGetExecuteFileData(query));
  const executeMacro = (body) => dispatch(fetchPostMacro(body));
  const cleanUp = () => dispatch(cleanUpMacro());
  const cleanUpMessage = () => dispatch(cleanUpMessageMacro());
  const cleanUpDataField = () => dispatch(cleanUpDataFieldMacro());



  return {
    error,
    success,
    isLoaded,
    data,
    fieldData,
    cleanUp,
    cleanUpMessage,
    getExecuteFileData,
    getFieldData,
    cleanUpDataField,
    executeMacro
  };

}
